import { APIProvider, useApiIsLoaded } from "@vis.gl/react-google-maps";
import ModalAddRate from "../../components/dynamic-rate/ContainerLeftEditRate/modal-add";
import { DynamicRateProvider } from "../../context/dynamicRate.context";
import ContentDynamicRoutes from "./content";

const DynamicRoutesInner = () => {
  const isLoaded = useApiIsLoaded();
  return (
    <DynamicRateProvider>
      <ContentDynamicRoutes isLoaded={isLoaded} />
      <ModalAddRate isLoaded={isLoaded} />
    </DynamicRateProvider>
  );
};

const DynamicRoutes = (props) => {
  return (
    <APIProvider
      apiKey={process.env.REACT_APP_MAPS_API}
      libraries={["places", "drawing"]}
    >
      <DynamicRoutesInner />
    </APIProvider>
  );
};

export default DynamicRoutes;
